import useModal from '@area2k/use-modal';
import React from 'react';
import Button from '@/components/Button';
import Card from '@/components/Card';
import Stack from '@/components/Stack';
import { Body } from '@/components/Typography';

type ModalProps = {
  reportData: any;
  isOpen: boolean;
  onClose: () => void;
};

const ReportModal = ({ reportData, isOpen, onClose }: ModalProps) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 99999,
      }}
    >
      <div
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          maxWidth: '800px',
          width: '90%',
          maxHeight: '90vh',
          overflow: 'auto',
        }}
      >
        <div
          style={{
            padding: '20px',
            borderBottom: '1px solid #eee',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h2 style={{ margin: 0 }}>Zeal Check Report Data</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
            }}
          >
            ×
          </button>
        </div>
        <Card.Section>
          <Stack vertical gap={24}>
            <div
              style={{
                width: '100%',
                maxHeight: '500px',
                overflowY: 'auto',
                padding: '16px',
                backgroundColor: '#f7f7f7',
                borderRadius: '4px',
                fontFamily: 'monospace',
              }}
            >
              {reportData ? (
                <pre
                  style={{
                    margin: 0,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                  }}
                >
                  {JSON.stringify(reportData, null, 2)}
                </pre>
              ) : (
                <Body>No report data available</Body>
              )}
            </div>
            <Stack justify="end">
              <Button
                a11yLabel="Close report data modal"
                appearance="primary"
                label="Close"
                onClick={onClose}
              />
            </Stack>
          </Stack>
        </Card.Section>
      </div>
    </div>
  );
};

export default ReportModal;
